import { render, staticRenderFns } from "./ModalNovedades.vue?vue&type=template&id=26ae56c6&scoped=true"
import script from "./ModalNovedades.vue?vue&type=script&lang=js"
export * from "./ModalNovedades.vue?vue&type=script&lang=js"
import style0 from "./ModalNovedades.vue?vue&type=style&index=0&id=26ae56c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ae56c6",
  null
  
)

export default component.exports